Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    progressTrackerTrackWidthSmall: 4,
    progressTrackerTrackWidthLarge: 6,
    progressTrackerTrackLengthMinimumSmall: 16,
    progressTrackerTrackLengthMinimumLarge: 24,
    progressTrackerTrackLengthDefault: 64,
    progressTrackerTrackBorderWidth: 1,
    progressTrackerTrackBorderRadius: 4,
    progressTrackerTrackBorderColorTheme: tokens.themeDecorativePaletteDefault,
    progressTrackerTrackBorderColorNeutral: tokens.themeDecorativeNeutralDefault,
    progressTrackerTrackBackgroundColorCompleteTheme: tokens.themeDecorativePaletteDefault,
    progressTrackerTrackBackgroundColorCompleteNeutral: tokens.themeDecorativeNeutralDefault,
    progressTrackerTrackBackgroundColorIncompleteTheme: tokens.themeSurfacePalette,
    progressTrackerTrackBackgroundColorIncompleteNeutral: tokens.themeDecorativeNeutralSubdued,
    progressTrackerMilestoneDiameterSmall: 16,
    progressTrackerMilestoneDiameterLarge: 24,
    progressTrackerMilestoneIconNamePastDefaultSmall: "check-knockout",
    progressTrackerMilestoneIconNamePastDefaultLarge: "check-circle-filled",
    progressTrackerMilestoneIconNamePastWarningSmall: "alert-knockout",
    progressTrackerMilestoneIconNamePastWarningLarge: "alert-filled",
    progressTrackerMilestoneIconNamePastErrorSmall: "error-knockout",
    progressTrackerMilestoneIconNamePastErrorLarge: "error-filled",
    progressTrackerMilestoneIconNamePresentWarningSmall: "alert-knockout",
    progressTrackerMilestoneIconNamePresentWarningLarge: "alert-filled",
    progressTrackerMilestoneIconNamePresentErrorSmall: "error-knockout",
    progressTrackerMilestoneIconNamePresentErrorLarge: "error-filled",
    progressTrackerMilestoneIconNameFutureWarningSmall: "alert-knockout",
    progressTrackerMilestoneIconNameFutureWarningLarge: "alert",
    progressTrackerMilestoneIconNameFutureErrorSmall: "error-knockout",
    progressTrackerMilestoneIconNameFutureErrorLarge: "error",
    progressTrackerMilestoneForegroundColorThemePastDefault: tokens.themeDecorativePaletteStrong,
    progressTrackerMilestoneForegroundColorThemePresentDefault: tokens.themeDecorativePaletteStrong,
    progressTrackerMilestoneForegroundColorThemePresentWarning: tokens.themeSupportInkWarning,
    progressTrackerMilestoneForegroundColorThemePresentError: tokens.themeSupportInkError,
    progressTrackerMilestoneForegroundColorThemeFutureDefault: "rgba(0, 0, 0, 0)",
    progressTrackerMilestoneForegroundColorThemeFutureWarning: tokens.themeSupportInkWarning,
    progressTrackerMilestoneForegroundColorThemeFutureError: tokens.themeSupportInkError,
    progressTrackerMilestoneForegroundColorNeutralPastDefault: tokens.themeDecorativeNeutralStrong,
    progressTrackerMilestoneForegroundColorNeutralPresentDefault: tokens.themeDecorativeNeutralStrong,
    progressTrackerMilestoneForegroundColorNeutralPresentWarning: tokens.themeSupportInkWarning,
    progressTrackerMilestoneForegroundColorNeutralPresentError: tokens.themeSupportInkError,
    progressTrackerMilestoneForegroundColorNeutralFutureDefault: "rgba(0, 0, 0, 0)",
    progressTrackerMilestoneForegroundColorNeutralFutureWarning: tokens.themeSupportInkWarning,
    progressTrackerMilestoneForegroundColorNeutralFutureError: tokens.themeSupportInkError,
    progressTrackerMilestoneBorderWidth: 2,
    progressTrackerMilestoneBorderRadius: 999,
    progressTrackerMilestoneBorderColorThemeFutureDefault: tokens.themeDecorativePaletteDefault,
    progressTrackerMilestoneBorderColorNeutralFutureDefault: tokens.themeDecorativeNeutralDefault,
    progressTrackerSpacingSmall: 4,
    progressTrackerSpacingLarge: 6,
    progressTrackerTextDefaultFontSize: 16,
    progressTrackerTextDefaultFontWeight: 400,
    progressTrackerTextDefaultLineHeight: "24px",
    progressTrackerTextDefaultForegroundColor: tokens.themeInkDefault
  }
};